<template>
  <header>
    <router-link to="/" class="logo">
      <img src="../assets/csepel_logo.png">
    </router-link>
    <ul class="menu" :class="{'mobile': isMobile(), 'open': menuOpen}" @click="toggleMenu()">
      <li>
        <router-link to="/">Rólunk</router-link>
        <ul class="submenu">
          <li>
            <router-link to="/">A programról</router-link>
          </li>
          <li>
            <router-link to="/team">A csapat</router-link>
          </li>
        </ul>
      </li>
      <li>
        <a>Nyitott gyárak hétvégéje</a>
        <ul class="submenu">
          <li>
            <router-link to="/opendays/2020">2020</router-link>
          </li>
          <li>
            <router-link to="/opendays/2019">2019</router-link>
          </li>
          <li>
            <router-link to="/news-opendays">Rólunk írták</router-link>
          </li>
        </ul>
      </li>
      <li>
        <router-link to="/documents">Dokumentumtár</router-link>
      </li>
    </ul>
    <div id="close-btn" :class="{'show': menuOpen}" @click="toggleMenu">
      <close-svg></close-svg>
    </div>
    <div id="hamburger" :class="{'show': !menuOpen}" aria-label="open menu" @click="toggleMenu"></div>
  </header>
</template>

<script>
  import CloseSvg from './close'

  export default {
    name: 'menu-nav',
    components: {CloseSvg},
    data() {
      return {
        menuOpen: false
      }
    },
    methods: {
      isMobile () {
        return window.innerWidth < 600
      },
      toggleMenu() {
        if (this.isMobile()) {
          this.menuOpen = !this.menuOpen
        }
      }
    }
  }
</script>

<style scoped>

  header {
    position: absolute;
    width: 100%;
    height: 60px;
    z-index: 1000;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background-color: #222;
    box-shadow: 0 4px 2px -3px rgba(0, 0, 0, 0.3);
  }

  .logo {
    position: absolute;
    top: calc(50% - 20px);
    left: 40px;
    height: 80%;

  }

  .logo img {
    height: 100%;
  }

  .menu {
    display: flex;
    align-items: center;
    height: 100%;
    top: 0;
    right: 0;
    padding: 0 20px;
    list-style: none;
  }

  .menu li {
    position: relative;
    display: flex;
    padding: 0 10px;
    height: 100%;
    align-items: center;
  }

  .menu li:hover {
    background: var(--colorA);
  }

  .menu a {
    font-size: 17px;
    color: #fff;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .submenu {
    position: absolute;
    width: 100%;
    min-width: 200px;
    top: 100%;
    left: 0;
    right: auto;
    visibility: hidden;
    opacity: 0;
    padding: 0;
    list-style: none;
    transform: translateY(-10%);
    background-color: var(--colorA);
    z-index: -1;
    box-shadow: 0 4px 2px -3px rgba(0, 0, 0, 0.3);
    /*border-top: 2px solid #fff;*/
  }

  .submenu li {
    width: 100%;
    text-align: left;
    padding: 15px 10px;
    margin: 0;
    border-top: 2px solid #ffffff;
  }

  .submenu li a {
    width: 100%;
    text-transform: none;
    color: #fff;
  }

  .menu li:hover .submenu {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
    transition: all .2s ease-in;
  }

  #hamburger,
  #close-btn {
    position: relative;
    display: none;
    width: 40px;
    height: 40px;
    right: 20px;
  }

  #hamburger::after {
    position: absolute;
    content: '';
    top: 9px;
    left: 0;
    width: 100%;
    height: 2px;
    background: #fff;
    box-shadow: 0 10px 0 #fff, 0 20px 0 #fff;
  }

  @media (max-width: 670px) {
    #hamburger,
    #close-btn {
      display: none;
    }

    #hamburger.show,
    #close-btn.show {
      display: block;
    }

    #close-btn {
      color: #fff;
      padding: 8px;
      border: 1px solid #fff;
    }

    header .logo {
      left: 20px;
    }

    .menu.mobile {
      position: fixed;
      display: none;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 20px;
      margin: 0;
      background: var(--colorB);
      box-sizing: border-box;
    }

    .menu.mobile.open {
      display: flex;
    }

    .menu.mobile li {
      height: auto;
      padding: 0 0 15px;
      margin: 0 0 15px;
      text-align: left;
      background: var(--colorB);
    }

    .menu.mobile li::after {
      position: absolute;
      content: '';
      width: 15px;
      height: 2px;
      left: 0;
      bottom: 0;
      background: #fff;
    }

    .menu.mobile .submenu {
      visibility: visible;
      opacity: 1;
      transform: translateY(0);
      padding-left: 40px;
      background: var(--colorB);
      box-shadow: none;
    }

    .menu.mobile .submenu li {
      border: 0;
      background: var(--colorB);
    }

    .menu.mobile a {
      font-size: 14px;
      max-width: 200px;
    }
  }

</style>
